export abstract class ApiConstants {
    public static URL1 = "https://uur1o1607i.execute-api.ap-southeast-1.amazonaws.com/customer/redcherry?uuid=rc000010&range_start=1567765670.394894&range_end=1567765695.394894&type=p2&aggregation=&measurement=power";
    public static URLJava = "http://localhost:8080/api/graphdata";
  //  public static URL = 'https://uur1o1607i.execute-api.ap-southeast-1.amazonaws.com/customer/redcherry';
    public static URL = 'https://api.open-meteo.com/v1/forecast' +
      '?latitude=12.9716' +
      '&longitude=77.5946' +
      '&hourly=temperature_2m,relative_humidity_2m,wind_speed_10m,shortwave_radiation' +
      '&past_days=7' +
      '&forecast_days=16' +
      '&timezone=Asia%2FKolkata';
    public static loginURL = 'https://ampohub-api.auth.ap-southeast-1.amazoncognito.com/token?grant_type=client_credentials&scope=ampohub/read';
    //public static loginURL = 'http://localhost/analytics-backend/login.php';
}